module.exports = __webpack_public_path__ + "img/028-development.33470eee.svg";